import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PaymentReportService = {
  getList: async (paymentTypeId, fromDate, toDate) => {
    const response = await apiService.get("/paymenttransactionlogs/report", {
      params: {
        paymentTypeId,
        fromDate,
        toDate,
      },
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });

    return response.data;
  },

  create: async (data) => {
    try {
      const response = await apiService.post(
        `/paymenttransactionlogs/report`,
        data,
        {
          headers: {
            authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  daybookList: async (fromDate, toDate) => {
    const response = await apiService.get(
      `/paymenttransactionlogs/daybook?fromDate=${fromDate}&toDate=${toDate}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  update: async (id, data) => {
    try {
      const response = await apiService.put(
        `/paymenttransactionlogs/report/${id}`,
        data,
        {
          headers: {
            authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/paymenttransactionlogs/report/${id}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  dayBookLog: async (fromDate, toDate) => {
    const response = await apiService.get(
      `/daybooklogs/list?fromDate=${fromDate}&toDate=${toDate}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },
  dayBookLogDetail: async (id) => {
    const response = await apiService.get(`/daybooklogs/${id}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default PaymentReportService;
